import { useState } from "react";
import { PasswordInput } from "@/components/shop/PasswordInput";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const inp = "h-12 w-full rounded-xl border border-black/10 bg-[#FFFBF3] px-4 text-sm outline-none focus:border-amber-500/60";
const btn = "h-12 w-full rounded-full bg-amber-500 font-display font-bold text-black transition-colors hover:bg-amber-400 disabled:opacity-60";
const Shell = ({ title, text, children }) => (
  <div className="mx-auto max-w-md px-4 py-16">
    <h1 className="font-display text-4xl font-bold tracking-tight">{title}</h1>
    <p className="mt-2 text-stone-600">{text}</p>
    <div className="mt-8 rounded-2xl border border-black/10 bg-white p-6">{children}</div>
  </div>
);

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, lang: localStorage.getItem("cs_lang") || "it" });
      setSent(true);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Password dimenticata" text="Inserisci l'email del tuo account: ti mandiamo un link per sceglierne una nuova.">
      {sent ? (
        <p className="text-sm text-stone-700" data-testid="forgot-sent">Se l'indirizzo è registrato riceverai a breve un'email con il link (valido 1 ora). Controlla anche la cartella spam.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email" className={inp} data-testid="forgot-email-input" />
          <button disabled={busy} className={btn} data-testid="forgot-submit">{busy ? "Invio..." : "Inviami il link"}</button>
        </form>
      )}
      <Link to="/accedi" className="mt-4 block text-center text-sm text-amber-600" data-testid="forgot-back-login">← Torna all'accesso</Link>
    </Shell>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";
  const invite = params.get("invito") === "1";
  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pwd });
      toast.success(invite ? "Accesso attivato: ora puoi entrare con la tua password" : "Password aggiornata: ora puoi accedere");
      navigate("/accedi", { replace: true });
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  if (!token) return <Shell title="Link non valido" text="Il link non è completo. Richiedine uno nuovo."><Link to="/password-dimenticata" className="text-amber-600">Richiedi un nuovo link →</Link></Shell>;
  return (
    <Shell title={invite ? "Attiva il tuo accesso" : "Nuova password"} text={invite ? "Scegli la password del tuo account amministratore (almeno 8 caratteri)." : "Scegli una nuova password di almeno 8 caratteri."}>
      <form onSubmit={submit} className="space-y-4">
        <PasswordInput required minLength={8} value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Nuova password" className={inp} data-testid="reset-password-input" />
        <PasswordInput required minLength={8} value={pwd2} onChange={(e) => setPwd2(e.target.value)} placeholder="Ripeti la password" className={inp} data-testid="reset-password-confirm" />
        <button disabled={busy} className={btn} data-testid="reset-submit">{busy ? "Salvataggio..." : "Salva la nuova password"}</button>
      </form>
    </Shell>
  );
}
